/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs */

const en_gc_search_guides_gridcraft_online_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The budget sample is a useful first workbook to explore online. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_online_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预算示例适合作为在线体验的第一个工作簿。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "The budget sample is a useful first workbook to explore online. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_imagecaption1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Imagecaption1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_imagecaption1(inputs)
	return zh_gc_search_guides_gridcraft_online_imagecaption1(inputs)
});
export { gc_search_guides_gridcraft_online_imagecaption1 as "gc.search_guides.gridcraft_online.imageCaption" }